import { Injectable } from '@angular/core';
import type { GraphQLParams, MaintenanceType } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';
import { config } from '@tag/graphql';

export interface Response {
  maintenanceTypes: { items: MaintenanceType[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class MaintenanceTypesGQL extends Query<
  Response,
  GraphQLParams<'maintenanceType'>
> {
  document = gql(config.maintenanceType.query);
}
